import { render, staticRenderFns } from "./pieChart.vue?vue&type=template&id=2f3fd618&scoped=true"
import script from "./pieChart.vue?vue&type=script&lang=js"
export * from "./pieChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3fd618",
  null
  
)

export default component.exports